import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	filterLabelListContainer: {
		display: 'inline-flex',
		padding: `0 ${theme.spacing.small}`,

		[getFromBreakpoint('lg')]: {
			padding: 0,
		},
	},
	clearFilters: { textDecoration: 'underline' },
	selectedFilters: {
		display: 'flex',
		flexFlow: 'row wrap',
		gap: theme.spacing.xxsmall,
		alignItems: 'center',
		marginBottom: theme.spacing.small,
	},
}));
